import { createContext, useContext, useState } from 'react';

const MoveOrderContext = createContext(null);

/**
 * MoveOrderProvider wraps children with the MoveOrder context.
 * @param {object} root0 - Component props
 * @param {import('react').ReactNode} root0.children - Child nodes to wrap
 * @returns {import('react').ReactElement} Context provider element
 */
export const MoveOrderProvider = ({ children }) => {
  const [dropDownSelected, setDropDownSelected] = useState({});

  return (
    <MoveOrderContext.Provider value={{ dropDownSelected, setDropDownSelected }}>{children}</MoveOrderContext.Provider>
  );
};

const noop = () => undefined;
const EMPTY_CONTEXT = { dropDownSelected: {}, setDropDownSelected: noop };
/**
 * Returns the MoveOrder context or a fallback empty context if called outside the provider.
 * @returns {object} The MoveOrder context value
 */
export const useMoveOrderContext = () => useContext(MoveOrderContext) ?? EMPTY_CONTEXT;
